import {IntegrationTypeNum} from 'enums/integrations';

export const getIsGoogleSitesDestination = (type: number): boolean =>
  type === IntegrationTypeNum.GOOGLE_SITES_DESTINATION;
